<div class="modal-header">
  <h5 class="text-info" id="exampleModalLongTitle">
    Select your nearest Center <i class="fa-solid fa-crosshairs-simple"></i>
  </h5>
  <button type="button" class="close btn-close" (click)="closeModal()"></button>
</div>
<div class="modal-body main-modal">
  <app-block-spinner [name]="'isSpinner'" [isSpinnerShow]="isSpinner"></app-block-spinner>
  @if(!isSpinner && outpostList.length > 0){
  <div class="row">
    @for (outpost of outpostList; track $index) {

    <div class="col-12 col-md-6 cursor-pointer d-flex" (click)="selectCenter(outpost)">
      <div class="loc-box mb-4 w-100">
        <h6 class="text-primary">
          <span class="">{{ outpost?.title }}</span> - @if(outpost?.distance){
          <span> {{ outpost?.distance }} mi </span>
          }
        </h6>
        <div class="d-flex justify-content-between my-3">
          @if(outpost?.mobile_no){
          <div>
            <div class="sub-title">Phone Number</div>
            <span>{{ outpost?.mobile_no }}</span>
          </div>
          } @if(outpost?.timing){
          <div>
            <div class="sub-title">Time</div>
            <span>{{ outpost?.timing }}</span>
          </div>
          }
        </div>
        <div>
          <div class="sub-title">Address</div>
          <span>{{ outpost?.address }}</span>
        </div>
      </div>
    </div>

    }
  </div>
  } @if(!isSpinner && !outpostList.length){
  <div class="text-center m-t-20 m-b-20">
    <span>No Records to Show!</span>
  </div>
  }
</div>